import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useClassName } from '../../../uiClassNames';
import { Root, IconWrap, ErrorIcon, ErrorText, Description } from './SubmitError.styles';

var SubmitError = function SubmitError(_ref) {
  var error = _ref.error,
      description = _ref.description;
  var className = useClassName('submitError');
  return _jsxs(Root, Object.assign({
    className: className
  }, {
    children: [_jsx(IconWrap, {
      children: _jsx(ErrorIcon, {})
    }), _jsxs("div", {
      children: [_jsx(ErrorText, Object.assign({
        id: "submit-error"
      }, {
        children: error
      })), _jsx(Description, {
        children: description
      })]
    })]
  }));
};

export default SubmitError;